import { atom } from "jotai";

import { currentModalStepAtom } from "../../stores";

export const enterReplacePlayerStepAtom = atom(
  null,
  (get, set, payload: { roundId: string }) => {
    const currentModalStep = get(currentModalStepAtom);
    set(currentModalStepAtom, {
      type:
        currentModalStep.type === "EditRoundsPrivate" ||
        currentModalStep.type === "AddPlayerPrivate"
          ? "ReplacePlayerPrivate"
          : "ReplacePlayer",
      roundId: payload.roundId,
    });
  }
);
